import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { AdditionalMessageStyles } from './AdditionalPDPLabel.style';
import { useAdditionalPDPLabel } from './hooks/useAdditionalPDPLabel';

const AdditionalPDPLabel = ({ label, type, productType, desktop }) => {
  const hookData = useAdditionalPDPLabel({ label, type, productType, desktop });

  const {
    title,
    processedDescription,
    moreInfoLink,
    linkDisplayText,
    iconStyle,
    containerClasses,
    hasTitle,
    hasDescription,
    hasMoreInfoLink,
    shouldRender,
  } = hookData;

  if (!shouldRender) {
    return null;
  }

  return (
    <div className={cx(...containerClasses)}>
      <div>
        <span className="icon" style={iconStyle} />
      </div>
      <div className="label-content">
        {hasTitle && <p className="label-header">{title}</p>}
        {hasDescription && (
          <p
            className="label-description"
            dangerouslySetInnerHTML={{
              __html: processedDescription,
            }}
          />
        )}
        {hasMoreInfoLink && (
          <div>
            <a className="underline" href={moreInfoLink} target="_blank" rel="noopener noreferrer">
              {linkDisplayText}
            </a>
            <span className="caret">
              <i className="csicon-right">
                <span className="sr-only">{linkDisplayText}</span>
              </i>
            </span>
          </div>
        )}
      </div>
      <style jsx>{AdditionalMessageStyles}</style>
    </div>
  );
};

AdditionalPDPLabel.propTypes = {
  label: PropTypes.shape({
    title: PropTypes.string,
    icon: PropTypes.string,
    description: PropTypes.string,
    moreInfoLink: PropTypes.string,
    moreInfoDisplayText: PropTypes.string,
  }),
  type: PropTypes.string,
  productType: PropTypes.string,
  desktop: PropTypes.bool,
};

AdditionalPDPLabel.defaultProps = {
  label: {},
  type: 'addToCart',
  productType: 'hardline',
  desktop: false,
};

export { AdditionalPDPLabel };
